<div class="background">
  <div class="inset" [@trigger]=currentState>
    <h1>{{config?.aboutH1}}</h1>
    <p>{{config?.aboutB2a}}</p>
  </div>
  <app-lessons-flat></app-lessons-flat>
  <div class="inset">
    <h1>{{config?.aboutH2}}</h1>
    <p> {{config?.aboutB2a}}
        
        <br><br>{{config?.aboutB2b}}
        </p>

        <h1>{{config?.aboutH3}}</h1>
        <p>{{config?.aboutB3a}} <span><strong class="bold">{{config?.aboutB3b}}</strong></span>{{config?.aboutB3c}}</p>


      <h1>{{config?.aboutH4}}</h1>
        
      <p>{{config?.aboutB4}}</p>

        <button class="lessonButton" (click)="gotoCurrentLesson()">{{config?.mainStartButton}}</button>
        <div class="container">
          <div>
            <p class="col1">{{config?.aboutB5a}}<span class="bold">{{config?.aboutB5b}}</span>{{config?.aboutB5c}}<span ><a href={{config?.aboutLink}} class="BoldText"> <u>{{config?.aboutB5d}}</u></a></span>
            </p>
           
          </div>
          <a href={{config?.aboutLink}} ><div class="col2"></div></a>
        </div>
  </div>
</div>